( function () {
    var sections = document.querySelectorAll( '.banner' );

    if ( ! sections.length || ! ( 'IntersectionObserver' in window ) ) {
        return;
    }

    if ( window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches ) {
        return;
    }

    sections.forEach( function ( section ) {
        var title = section.querySelector( '.banner__title' );
        var text = section.querySelector( '.banner__text' );
        var styles = window.getComputedStyle( section );
        var inset = styles.getPropertyValue( '--banner-reveal-inset' ).trim() || '12%';
        var textLead = parseDuration( styles.getPropertyValue( '--banner-reveal-text-lead' ), 250 );
        var titleRevealedAt = null;
        var textRevealed = false;
        var observer;
        var resizeTimer;

        if ( ! title && ! text ) {
            section.setAttribute( 'data-reveal-skip', '' );
            return;
        }

        if ( title ) {
            splitTitle( title );
        }

        section.classList.add( 'is-reveal' );
        assignLines( title );

        observer = new IntersectionObserver( function ( entries ) {
            entries.forEach( function ( entry ) {
                if ( entry.isIntersecting && entry.target === title ) {
                    revealTitle();
                }
            } );

            entries.forEach( function ( entry ) {
                if ( entry.isIntersecting && entry.target === text ) {
                    revealText();
                }
            } );
        }, {
            rootMargin: '0px 0px -' + inset + ' 0px',
            threshold: 0
        } );

        // Let the hidden state paint before observing, so content already on screen still animates in.
        window.requestAnimationFrame( function () {
            window.requestAnimationFrame( function () {
                if ( title ) {
                    observer.observe( title );
                }

                if ( text ) {
                    observer.observe( text );
                }

                revealIfPageEnds();
            } );
        } );

        onRevealPageEnd( revealIfPageEnds );
        window.addEventListener( 'resize', onResize );

        function onResize() {
            window.clearTimeout( resizeTimer );
            resizeTimer = window.setTimeout( function () {
                if ( titleRevealedAt === null ) {
                    assignLines( title );
                }

                revealIfPageEnds();
            }, 150 );
        }

        function revealIfPageEnds() {
            var atEnd = window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 4;

            if ( ! atEnd ) {
                return;
            }

            revealTitle();
            revealText();
        }

        function revealTitle() {
            if ( ! title || titleRevealedAt !== null ) {
                return;
            }

            titleRevealedAt = Date.now();
            section.classList.add( 'is-title-inview' );
            observer.unobserve( title );
        }

        function revealText() {
            var lead = 0;

            if ( ! text || textRevealed ) {
                return;
            }

            if ( title && titleRevealedAt === null && isOnScreen( title ) ) {
                revealTitle();
            }

            if ( titleRevealedAt !== null ) {
                lead = Math.max( 0, textLead - ( Date.now() - titleRevealedAt ) );
            }

            textRevealed = true;
            observer.unobserve( text );
            window.setTimeout( function () {
                section.classList.add( 'is-text-inview' );
            }, lead );
        }
    } );

    function onRevealPageEnd( callback ) {
        if ( window.JPSReveal ) {
            window.JPSReveal.onEnd( callback );
            return;
        }

        window.addEventListener( 'scroll', callback, { passive: true } );
    }

    function splitTitle( title ) {
        var text = title.textContent;
        var fragment = document.createDocumentFragment();

        title.setAttribute( 'aria-label', text.trim() );

        text.split( /(\s+)/ ).forEach( function ( part ) {
            var mask;
            var word;

            if ( ! part ) {
                return;
            }

            if ( /^\s+$/.test( part ) ) {
                fragment.appendChild( document.createTextNode( ' ' ) );
                return;
            }

            mask = document.createElement( 'span' );
            mask.className = 'banner__title-mask';
            mask.setAttribute( 'aria-hidden', 'true' );

            word = document.createElement( 'span' );
            word.className = 'banner__title-word';
            word.textContent = part;

            mask.appendChild( word );
            fragment.appendChild( mask );
        } );

        title.textContent = '';
        title.appendChild( fragment );
    }

    function assignLines( title ) {
        var line = -1;
        var lastTop = null;

        if ( ! title ) {
            return;
        }

        title.querySelectorAll( '.banner__title-mask' ).forEach( function ( mask ) {
            var top = mask.offsetTop;

            if ( lastTop === null || Math.abs( top - lastTop ) > 4 ) {
                line++;
                lastTop = top;
            }

            mask.firstChild.style.setProperty( '--banner-reveal-line', String( line ) );
        } );
    }

    function isOnScreen( element ) {
        var rect = element.getBoundingClientRect();

        return rect.top < window.innerHeight && rect.bottom > 0;
    }

    function parseDuration( raw, fallback ) {
        raw = ( raw || '' ).trim();

        if ( raw.slice( -2 ) === 'ms' ) {
            return parseFloat( raw ) || fallback;
        }

        return ( parseFloat( raw ) * 1000 ) || fallback;
    }
} )();
